import { render, staticRenderFns } from "./ModalNotificationError.vue?vue&type=template&id=1b82475a&scoped=true&"
import script from "./ModalNotificationError.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationError.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotificationError.vue?vue&type=style&index=0&id=1b82475a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b82475a",
  null
  
)

export default component.exports